import PropTypes from 'prop-types';

export const adminPropTypes = {
  authenticate: PropTypes.func,
  cancelBooking: PropTypes.func,
  createEditableContent: PropTypes.func,
  deleteEditableContent: PropTypes.func,
  deleteWidgetBooking: PropTypes.func,
  generateVirtualCreditCard: PropTypes.func,
  getAllCompanies: PropTypes.func,
  getAllFeatureFlags: PropTypes.func,
  getWidgetBooking: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  login: PropTypes.func,
  logout: PropTypes.func,
  patchWidgetBooking: PropTypes.func,
  postWidgetBooking: PropTypes.func,
  setCancellationConditions: PropTypes.func,
  setIsLoading: PropTypes.func,
  setOpenCancellationModal: PropTypes.func,
  setSegmentData: PropTypes.func,
  ticketCancellation: PropTypes.shape({
    conditions: PropTypes.string,
    isLoading: PropTypes.bool,
    openCancellationModal: PropTypes.bool,
    segmentData: PropTypes.string,
  }),
  updateCompanyVisibility: PropTypes.func,
  updateCompanySelfCancellation: PropTypes.func,
  updateEditableContent: PropTypes.func,
  updateFeatureFlag: PropTypes.func,
  virtualCreditCard: PropTypes.shape({
    cvc: PropTypes.string,
    expiryMonth: PropTypes.string,
    expiryYear: PropTypes.string,
    number: PropTypes.string,
  }),
};
